const state = {
  isActiveAlertRedirect: false,
};

const getters = {
  GetIsActiveAlertRedirect: (state) => {
    return state.isActiveAlertRedirect;
  },
};

export { getters, state };
